/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Trim_Event_TimeInputs */

const en_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Trim Event Time`)
};

const fr_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rogner automatiquement la durée de l'événement`)
};

const de_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Trim-Ereigniszeit`)
};

const it_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo evento di rifinitura automatica`)
};

const ru_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время события автоматической обрезки`)
};

const es_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de evento de ajuste automático`)
};

const zh_cn2_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动修剪事件时间`)
};

const ja_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動トリムイベント時間`)
};

const hi_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो ट्रिम इवेंट समय`)
};

const pt_pt2_options_editor_auto_trim_event_time = /** @type {(inputs: Options_Editor_Auto_Trim_Event_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horário do evento de ajuste automático`)
};

/**
* | output |
* | --- |
* | "Auto Trim Event Time" |
*
* @param {Options_Editor_Auto_Trim_Event_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_trim_event_time = /** @type {((inputs?: Options_Editor_Auto_Trim_Event_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Trim_Event_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_trim_event_time(inputs)
	if (locale === "de") return de_options_editor_auto_trim_event_time(inputs)
	if (locale === "it") return it_options_editor_auto_trim_event_time(inputs)
	if (locale === "ru") return ru_options_editor_auto_trim_event_time(inputs)
	if (locale === "es") return es_options_editor_auto_trim_event_time(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_trim_event_time(inputs)
	if (locale === "ja") return ja_options_editor_auto_trim_event_time(inputs)
	if (locale === "hi") return hi_options_editor_auto_trim_event_time(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_trim_event_time(inputs)
	return en_options_editor_auto_trim_event_time(inputs)
});